<fieldset cdxFieldset [formGroup]="formGroup">
	<div  *ngFor="let slot of slots">
		<form-flexible-selection-tile
			class="vertical"
			inputId="{{ date }}~slot?.id"
			attr.data-cy="timeslot-flexible"
			attr.data-ft="fullstory-flexible-delivery"
			inputValue=	"{{ slot?.id }}"
			i18n="@@selection-time"
			[formControlName]="controlName"
			[successIcon]="false"
			[label]="getLabel( slot?.id )"
			(change) = "selectSlot(slot)"
		/>
	</div>
</fieldset>
